import { t } from '@lingui/macro';
import React from 'react';
import { connect } from 'react-redux';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import * as V from '../../../constants/variables';
import { getStartsCompetitorsColorScope } from '../../../utils/getStartsCompetitorsColorScope';
import { MultiGroupFilter } from '../MultiGroupFilter';
import { ColoredItemsLegend } from '../../LegendRenderer/types/ColoredItemsLegend';
import { DynamicOperatorsLegend } from '../DynamicOperatorsLegend';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';

const getTrackLabel = (value, mode) => `≥ ${value} ${(mode === 'ms') ? '%' : t`стартов`}`;
const StartsCompetitorsFilterComponent = ({ CompetitorsDays, onChangeMapFilters, Competitor, CompetitorsPrefix, trackStartsCompetitorsAvailableOperators }) => {
    const isStartsOrMs = CompetitorsPrefix === 'starts' || CompetitorsPrefix === 'ms';
    const onChange = ({ target: { value } }) => {
        const key = 'CompetitorsDays';
        onChangeMapFilters(key, +value);
    };
    const onChangeCompetitors = ({ target: { value } }) => {
        const key = 'Competitor';
        onChangeMapFilters(key, value);
    };
    const onChangeMode = mode => {
        const key = 'CompetitorsPrefix';
        onChangeMapFilters(key, mode);
    };
    const getModeTitle = () => {
        if (CompetitorsPrefix === 'starts') return t`Агрегированные старты:`;
        if (CompetitorsPrefix === 'ms') return t`Доля рынка:`;
        return t`Лидер стартов:`;
    };
    const footerContent = () => {
        if (isStartsOrMs) {
            const items = getStartsCompetitorsColorScope(CompetitorsDays, CompetitorsPrefix)
                .map((value, index) => ({
                    id: value,
                    label: { id: `label_${value}`, message: getTrackLabel(value, CompetitorsPrefix) },
                    fill: V.startFinishTrackHexagonColor[index],
                }))
                .filter((_, index) => index !== 0);
            return (
                <ColoredItemsLegend
                    items={items}
                    icon={LEGEND_ICON_TYPES.HEXAGON}
                    renderConfig={{
                        showIcon: true,
                        iconSize: '30px',
                        iconOpacity: 0.8,
                        fontSize: '0.85rem',
                    }}
                />
            );
        }
        // Режим "лидер стартов": динамический список операторов из тайлов на экране
        return (
            <div>
                <DynamicOperatorsLegend availableOperators={trackStartsCompetitorsAvailableOperators} />
                <div style={{ padding: '10px' }}>
                    <small>
                        {
                            getStartsCompetitorsColorScope(CompetitorsDays, CompetitorsPrefix).map((value, index) => index !== 0 ? (
                                t`Учитываются локации с общим количеством стартов более ${value}`
                            ) : null)
                        }
                    </small>
                </div>
            </div>
        );
    };
    return (
        <MultiGroupFilter
            isVisible={true}
            groups={[
                {
                    id: 'mode',
                    type: 'button-group',
                    value: CompetitorsPrefix,
                    onChange: e => onChangeMode(e.target.value),
                    options: V.startsCompetitorsModeOptions.map(({ type, label }) => ({
                        value: type,
                        label,
                    })),
                },
                {
                    id: 'competitors',
                    title: getModeTitle(),
                    value: Competitor,
                    onChange: onChangeCompetitors,
                    options: V.CompetitorsFilterValues.map(({ value, label }) => ({
                        value,
                        label: t`${label}`,
                    })),
                    when: isStartsOrMs,
                },
                {
                    id: 'days',
                    title: t`Период:`,
                    value: String(CompetitorsDays),
                    onChange,
                    options: V.startsCompetitorsFilterValues.map(value => ({
                        value,
                        label: t`${value} дней`,
                    })),
                },
            ]}
            footer={footerContent}
        />
    );
};
const mapStateToProps = ({ mapFilters: { CompetitorsDays, CompetitorsPrefix, Competitor, trackStartsCompetitorsAvailableOperators } }) => ({
    CompetitorsDays, CompetitorsPrefix, Competitor, trackStartsCompetitorsAvailableOperators,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(StartsCompetitorsFilterComponent);

export const StartsCompetitorsFilter = withDisplayedLayersCheck(ConnectedComponent, 'Агрегированные старты (конкуренты)');
